<style src="./ContextPopup.scss" lang="scss"></style>
<template>
  <aside
    @click.stop
    v-click-outside="closePanel"
    v-shortkey="['esc']"
    @shortkey="closePanel"
    class="context-popup"
    :style="positionStyle">
    <div
      class="contentpopup"
      :style="{ 'width': width }">
      <slot>
      </slot>
    </div>
  </aside>
</template>

<script>
export default {
  name: 'ContextPopup',
  props: {
    width: {
      default: 'auto'
    },
    position: {
      default: 'center'
    }
  },
  computed: {
    positionStyle () {
      switch (this.position) {
        case 'center':
          return { 'width': this.width, 'left': '-50%' }
        case 'left':
          return { 'width': this.width, 'right': '0px' }
        case 'right':
          return { 'width': this.width, 'left': '0px' }
        default:
          return { 'width': this.width, 'left': '-50%' }
      }
    }
  },
  methods: {
    closePanel () {
      this.$emit('close')
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/primitives/context-popup/ContextPopup.vue